import Model from "../../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn } from "../../Styles/InputStyles";

const CancelReservation = ({
    setIsCancelReservation,
    selectedData,
    cancelReservationLoading,
    cancelReservationMutate,
}) => {
    const handleCancelSubmit = () => {
        cancelReservationMutate({ tenantId: selectedData?.data?.id || selectedData?.tenantId });
    };

    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsCancelReservation}
            title="Reservation Cancellation Confirmation"
        >
            <WarningText>
                Please confirm if you wish to cancel the scheduled reservation process.
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={() => setIsCancelReservation(false)}
                >
                    Cancel
                </SideCancelBtn>
                <button
                    onClick={handleCancelSubmit}
                    disabled={cancelReservationLoading}
                    className="rounded-md shadow-md  border border-rose-600 bg-white text-rose-600 hover:bg-rose-600 hover:text-white text-sm w-32  md:w-44 h-12 grid place-items-center disabled:opacity-50 disabled:cursor-not-allowed  md:text-base"
                    
                >
                    {cancelReservationLoading ? "Loading..." : "Cancel Reservation"}
                </button>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default CancelReservation;
